// extracted by mini-css-extract-plugin
export default {"catalogByService":"c-k_eE"};